<div>
  {{ data.type == "success" ? "Sucesso" : "Atenção" }}
</div>
<div class="content-style">
  {{ data.message }}
</div>
<div style="text-align: end">
  <button mat-flat-button (click)="snackBarRef.dismiss()">
    {{ data.buttonText }}
  </button>
</div>
